import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'swb-homepage',
  templateUrl: './homepage.component.html'
})
export class HomepageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
